import React, { useContext } from 'react';
import { compact } from 'lodash';

import Chapter from '../../Chapter';
import ChapterPlayerContext from '../../ChapterPlayer.context';
import { AssetType } from '../../../../utils/storage';

import NbyAttract, {
    calculateDuration,
    calculateExitDuration,
} from './nby/screens/attract';
import { MediaType } from './shared';

import './styles/fonts.scss';


type NbyAttractData = {
    list?: Array<{
        backgroundMedia?: MediaType,
        media?: MediaType[],
        animationVariant?: string,
        duration?: number,
    } | null>,
};

export default class NbyAttractChapter extends Chapter<NbyAttractData> {
    component = () => {
        const {
            width,
            height,
        } = useContext(ChapterPlayerContext);

        return (
            <div
                style={{
                    width: width || '100%',
                    height: height || '100%',
                }}
            >
                <NbyAttract {...this.data} />
            </div>
        );
    }

    fonts = [
        'helvetica-neue-hoi-ehq',
    ]

    canLoop = true

    calculateDuration() {
        const data = {
            list: this.data.list || [],
        };

        return (calculateDuration(data) - calculateExitDuration()) / 1000;
    }

    getAssetsToCache(): AssetType[] {
        const assets = (this.data.list || []).flatMap(item => ([
            item?.backgroundMedia,
            ...(item?.media || []),
        ]));

        return compact(assets).filter(media => media?.url);
    }
}
